import { API } from "aws-amplify";
import {
  AccountType,
  setAccounts,
  setSelectedAccount,
} from "../../redux/userSlice";
import { AppDispatch } from "../../redux/store";
import { APIS } from "../../utils/apiUtils";
import { setServiceData, setServiceList } from "../../redux/serviceSlice";
import {
  getPersistedSelectedAccountId,
  persistSelectedAccountId,
} from "../../utils/accountSelectionStorage";

const getPreferredAccount = (
  accounts: Array<AccountType>,
  userId: string | undefined,
  currentSelectedAccount?: AccountType
): AccountType | undefined => {
  if (!accounts.length) return undefined;

  const persistedSelectedAccountId = getPersistedSelectedAccountId(userId);
  if (persistedSelectedAccountId) {
    const persistedSelection = accounts.find(
      ({ accountId }) => accountId === persistedSelectedAccountId
    );
    if (persistedSelection) return persistedSelection;
  }

  if (currentSelectedAccount) {
    const existingSelection = accounts.find(
      ({ accountId }) => accountId === currentSelectedAccount.accountId
    );
    if (existingSelection) return existingSelection;
  }

  const createdAccount = accounts.find((acc) => acc.createdBy === userId);
  if (createdAccount) return createdAccount;

  // Testing fallback: allow switching to any returned account even when
  // current user is not the account creator.
  return accounts[0];
};

export const getUserAccounts = async (
  userId: string | undefined,
  dispatch: AppDispatch,
  currentSelectedAccount?: AccountType
) => {
  const { accounts = [] } = await API.get(
    APIS.USER_API,
    "/accounts-and-teams",
    {}
  );
  const selectedAccount = getPreferredAccount(
    accounts,
    userId,
    currentSelectedAccount
  );

  dispatch(setAccounts(accounts));

  if (selectedAccount?.accountId !== currentSelectedAccount?.accountId) {
    dispatch(setSelectedAccount(selectedAccount));
  }

  persistSelectedAccountId(userId, selectedAccount?.accountId);
};

export const getServicesList = async (
  accountId: string | undefined,
  dispatch: AppDispatch
) => {
  const { serviceList, serviceData } = await API.get(
    APIS.USER_API,
    "/services",
    { queryStringParameters: { accountId } }
  );
  dispatch(setServiceList(serviceList));
  dispatch(setServiceData(serviceData));
};
